import { NgModule } from '@angular/core';
import { AuthModule } from '@spaq/modules/auth';
import { LoginAlreadyLoggedInComponent, LoginEmailComponent, LoginFormEmailComponent } from '@spaq/modules/login/components';
import { LoginEmailPageComponent } from '@spaq/modules/login/pages';
import { SessionModule } from '@spaq/modules/session';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [
		FormsModule,
		RecaptchaFormsModule,
		SharedCommonModule,
		AuthModule,
		SessionModule,
		FormModule,
		SharedComponentsModule,
		SharedFormModule,
		RecaptchaModule
	],
	declarations: [LoginEmailComponent, LoginFormEmailComponent, LoginAlreadyLoggedInComponent, LoginEmailPageComponent],
	exports: [LoginEmailComponent, LoginFormEmailComponent, LoginAlreadyLoggedInComponent],
	providers: [
		{
			provide: RECAPTCHA_SETTINGS,
			useValue: { siteKey: '6LeIImIjAAAAAGDVZwBW7r4VyhbH4aIbENE7Jufm' } as RecaptchaSettings
		},
		{
			provide: RECAPTCHA_LANGUAGE,
			useValue: 'fr' // use French language
		}
	],

	entryComponents: [LoginEmailComponent]
})
export class LoginModule {}
